import React, { lazy, Suspense, useState, useEffect } from 'react';
import axios from 'axios';
import { ipAddress } from '../../config';
import HeroSection from './HeroSection/HeroSection';
import PartnerDashboard from './Partner/CardsDashboard';
import NumOfVideosOfEahResto from './Partner/NumOfVideosOfEahResto';

// Charts pull in chart.js + react-chartjs-2 (heavy). Lazy-load so the cards paint first.
const PartnerCharts = lazy(() => import('./Partner/Charts'));

const Home = () => {
  const [partnerToken, setPartnerToken] = useState(localStorage.getItem('partnerToken'));
  const [data, setData] = useState(null);
  const [analytics, setAnalytics] = useState(null);

  // Detect login/logout. The `storage` event covers other tabs; the short poll
  // covers a same-tab login — but only while logged OUT, so we never churn the
  // dashboard with a re-render every second once the partner is in.
  useEffect(() => {
    const sync = () => setPartnerToken(localStorage.getItem('partnerToken'));
    window.addEventListener('storage', sync);

    let intervalId;
    if (!partnerToken) {
      intervalId = setInterval(() => {
        const t = localStorage.getItem('partnerToken');
        if (t) setPartnerToken(t);
      }, 1000);
    }

    return () => {
      window.removeEventListener('storage', sync);
      if (intervalId) clearInterval(intervalId);
    };
  }, [partnerToken]);

  // One round trip for the partner-scoped dashboard + one for the global analytics,
  // in parallel — replaces the ~15 separate requests the dashboard used to fire.
  useEffect(() => {
    const partnerId = localStorage.getItem('partnerId');
    if (!partnerToken || !partnerId) return;
    const headers = { Authorization: `${partnerToken}` };

    const fetchAll = async () => {
      try {
        const [dash, glob] = await Promise.all([
          axios.post(`${ipAddress}/api/PartnerAccountRoutes/get_partner_dashboard`, { partnerId }, { headers }),
          axios.post(`${ipAddress}/api/PartnerAccountRoutes/get_partner_global_analytics`, {}, { headers }),
        ]);
        setData(dash.data);
        setAnalytics(glob.data);
      } catch (error) {
        console.error('Error fetching partner dashboard:', error);
      }
    };

    fetchAll();
  }, [partnerToken]);

  return (
    <div>
      {!partnerToken && <HeroSection />}
      {partnerToken &&
        <div style={{ margin: 20 }}>
          <PartnerDashboard data={data} />
          <NumOfVideosOfEahResto data={data} />
          <Suspense fallback={null}>
            <PartnerCharts data={data} analytics={analytics} />
          </Suspense>
        </div>
      }
    </div>
  );
};

export default Home;
